module.exports = __webpack_public_path__ + "img/gender.e16b376d.svg";